import { Waypoints } from "lucide-react";

import { MenuLink } from "./menu-link";

export type MenuProjectProps = {
  projectId: string;
};

// TODO ::: update settings page to reflect SSDI only projects
export const MenuProject = ({ projectId }: MenuProjectProps) => {
  return (
    <>
      <MenuLink url={`/projects/${projectId}`} title="Scenarios" testLabel={"scenarios"} end={true}>
        <Waypoints size="lg" />
      </MenuLink>
      {/* <MenuLink url={`/projects/${projectId}/settings`} title="Project Settings" testLabel={"project-settings"}>
        <Wrench size="lg" />
      </MenuLink> */}
    </>
  );
};
